import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';

import { useTrendAdmin } from '../TrendAdminContext';

export default function ArchiveDialog() {
  const {
    archiveConfirmOpen,
    setArchiveConfirmOpen,
    archiveDays,
    setArchiveDays,
    handleArchiveOldArticles,
  } = useTrendAdmin();

  return (
    <Dialog open={archiveConfirmOpen} onClose={() => setArchiveConfirmOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Arkivera gamla artiklar</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Artiklar äldre än det valda antalet dagar sätts till "dold" och visas inte längre. Åtgärden kan inte ångras automatiskt.
        </Typography>
        <TextField
          select
          fullWidth
          size="small"
          label="Äldre än"
          value={archiveDays}
          onChange={(e) => setArchiveDays(Number(e.target.value))}
        >
          <MenuItem value={7}>7 dagar</MenuItem>
          <MenuItem value={14}>14 dagar</MenuItem>
          <MenuItem value={30}>30 dagar</MenuItem>
          <MenuItem value={60}>60 dagar</MenuItem>
          <MenuItem value={90}>90 dagar</MenuItem>
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setArchiveConfirmOpen(false)}>Avbryt</Button>
        <Button variant="contained" color="warning" onClick={handleArchiveOldArticles}>
          Arkivera
        </Button>
      </DialogActions>
    </Dialog>
  );
}
